import { FormattedMessage } from 'react-intl';

// assets
import SpeedTwoToneIcon from '@mui/icons-material/SpeedTwoTone';
import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';
import ViewKanbanTwoToneIcon from '@mui/icons-material/ViewKanbanTwoTone';
import CalendarMonthTwoToneIcon from '@mui/icons-material/CalendarMonthTwoTone';
import AssignmentTwoToneIcon from '@mui/icons-material/AssignmentTwoTone';
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';
import GavelTwoToneIcon from '@mui/icons-material/GavelTwoTone';
import BusinessCenterTwoToneIcon from '@mui/icons-material/BusinessCenterTwoTone';
import ViewQuiltTwoToneIcon from '@mui/icons-material/ViewQuiltTwoTone';
import WidgetsTwoToneIcon from '@mui/icons-material/WidgetsTwoTone';
import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import ReceiptTwoToneIcon from '@mui/icons-material/ReceiptTwoTone';
import ConfirmationNumberTwoToneIcon from '@mui/icons-material/ConfirmationNumberTwoTone';
import SecurityTwoToneIcon from '@mui/icons-material/SecurityTwoTone';
import GroupsTwoToneIcon from '@mui/icons-material/GroupsTwoTone';
import Inventory2TwoToneIcon from '@mui/icons-material/Inventory2TwoTone';
import EventRepeatTwoToneIcon from '@mui/icons-material/EventRepeatTwoTone';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import HandshakeTwoToneIcon from '@mui/icons-material/HandshakeTwoTone';
import PostAddTwoToneIcon from '@mui/icons-material/PostAddTwoTone';

const baseSideMenu = [
    {
        id: 'dashboard',
        // title: <FormattedMessage id="menuitems-dashboard-title" />,
        // caption: <FormattedMessage id="menuitems-dashboard-caption" />,
        type: 'group',
        children: [
            {
                id: 'dashboard-default',
                title: <FormattedMessage id="menuitems-dashboard-default-title" />,
                // caption: <FormattedMessage id="menuitems-dashboard-default-caption" />,
                type: 'item',
                url: '/dashboard/default',
                icon: <SpeedTwoToneIcon fontSize="small" />
            },
            {
                id: 'dashboard-personal',
                title: <FormattedMessage id="menuitems-dashboard-personal-title" />,
                // caption: <FormattedMessage id="menuitems-dashboard-personal-caption" />,
                type: 'collapse',
                icon: <DashboardTwoToneIcon fontSize="small" />,
                children: [
                    {
                        id: 'dashboard-personal-kanban',
                        title: <FormattedMessage id="menuitems-dashboard-personal-kanban-title" />,
                        // caption: <FormattedMessage id="menuitems-dashboard-personal-kanban-caption" />,
                        type: 'item',
                        url: '/dashboard/personal/kanban',
                        icon: <ViewKanbanTwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'dashboard-personal-calendar',
                        title: <FormattedMessage id="menuitems-dashboard-personal-calendar-title" />,
                        // caption: <FormattedMessage id="menuitems-dashboard-personal-calendar-caption" />,
                        type: 'item',
                        url: '/dashboard/personal/calendar',
                        icon: <CalendarMonthTwoToneIcon fontSize="small" />
                    }
                ]
            }
        ]
    },
    {
        id: 'workmgmt',
        // title: <FormattedMessage id="menuitems-workmgmt-title" />,
        // caption: <FormattedMessage id="menuitems-workmgmt-caption" />,
        type: 'group',
        children: [
            {
                id: 'workmgmt-busopp',
                title: <FormattedMessage id="menuitems-workmgmt-busopp-title" />,
                // caption: <FormattedMessage id="menuitems-workmgmt-busopp-caption" />,
                type: 'collapse',
                icon: <AssignmentTwoToneIcon fontSize="small" />,
                children: []
            },
            {
                id: 'workmgmt-workorder',
                title: <FormattedMessage id="menuitems-workmgmt-workorder-title" />,
                // caption: <FormattedMessage id="menuitems-workmgmt-workorder-caption" />,
                type: 'collapse',
                icon: <AssignmentTwoToneIcon fontSize="small" />,
                children: []
            },
            {
                id: 'workmgmt-ticket',
                title: <FormattedMessage id="menuitems-workmgmt-ticket-title" />,
                // caption: <FormattedMessage id="menuitems-workmgmt-ticket-caption" />,
                type: 'collapse',
                // url: 'workmgmt/tickets',
                icon: <ReceiptTwoToneIcon fontSize="small" />,
                children: [
                    {
                        id: 'workmgmt-ticket-create',
                        title: <FormattedMessage id="menuitems-workmgmt-ticket-create" />,
                        // caption: <FormattedMessage id="menuitems-workmgmt-ticket-create-caption" />,
                        type: 'item',
                        url: '/workmgmt/tickets/create',
                        icon: <PostAddTwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'workmgmt-ticket-list',
                        title: <FormattedMessage id="menuitems-workmgmt-ticket-title" />,
                        // caption: <FormattedMessage id="menuitems-workmgmt-ticket-create-caption" />,
                        type: 'item',
                        url: '/workmgmt/tickets/list',
                        icon: <ReceiptTwoToneIcon fontSize="small" />
                    }
                ]
            }
        ]
    },
    {
        id: 'admin',
        title: <FormattedMessage id="menuitems-admin-title" />,
        // caption: <FormattedMessage id="menuitems-admin-caption" />,
        type: 'group',
        children: [
            {
                id: 'admin-crm',
                title: <FormattedMessage id="menuitems-admin-crm-title" />,
                // caption: <FormattedMessage id="menuitems-admin-crm-caption" />,
                type: 'collapse',
                icon: <PeopleAltTwoToneIcon fontSize="small" />,
                children: [
                    {
                        id: 'admin-crm-client',
                        title: <FormattedMessage id="menuitems-admin-crm-client-title" />,
                        // caption: <FormattedMessage id="menuitems-admin-crm-client-caption" />,
                        type: 'item',
                        url: '/admin/crm/client/list',
                        icon: <PeopleAltTwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'admin-crm-contract',
                        title: <FormattedMessage id="menuitems-admin-crm-contract-title" />,
                        // caption: <FormattedMessage id="menuitems-admin-crm-contract-caption" />,
                        type: 'item',
                        url: '/admin/crm/contract/list',
                        icon: <GavelTwoToneIcon fontSize="small" />
                    }
                ]
            },
            {
                id: 'admin-hr',
                title: <FormattedMessage id="menuitems-admin-hr-title" />,
                // caption: <FormattedMessage id="menuitems-admin-hr-caption" />,
                type: 'collapse',
                icon: <BusinessCenterTwoToneIcon fontSize="small" />,
                children: [
                    {
                        id: 'admin-hr-department',
                        title: <FormattedMessage id="menuitems-admin-hr-department-title" />,
                        // caption: <FormattedMessage id="menuitems-admin-hr-department-caption" />,
                        type: 'item',
                        url: '/admin/hr/department/list',
                        icon: <BusinessCenterTwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'admin-hr-employee',
                        title: <FormattedMessage id="menuitems-admin-hr-employee-title" />,
                        // caption: <FormattedMessage id="menuitems-admin-hr-employee-caption" />,
                        type: 'item',
                        url: '/admin/hr/employee/list',
                        icon: <PeopleAltTwoToneIcon fontSize="small" />
                    }
                ]
            },
            {
                id: 'admin-tplmgmt',
                title: <FormattedMessage id="menuitems-admin-tplmgmt-title" />,
                // caption: <FormattedMessage id="menuitems-admin-tplmgmt-caption" />,
                type: 'collapse',
                icon: <ViewQuiltTwoToneIcon fontSize="small" />,
                children: [
                    {
                        id: 'admin-tplmgmt-busopp',
                        title: <FormattedMessage id="menuitems-admin-tplmgmt-busopp-title" />,
                        // caption: <FormattedMessage id="menuitems-admin-tplmgmt-busopp-caption" />,
                        type: 'item',
                        url: '/admin/tplmgmt/busopp/list',
                        icon: <ViewQuiltTwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'admin-tplmgmt-workorder',
                        title: <FormattedMessage id="menuitems-admin-tplmgmt-workorder-title" />,
                        // caption: <FormattedMessage id="menuitems-admin-tplmgmt-workorder-caption" />,
                        type: 'item',
                        url: '/admin/tplmgmt/workorder/list',
                        icon: <ViewQuiltTwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'admin-tplmgmt-followup',
                        title: <FormattedMessage id="menuitems-admin-tplmgmt-followup-title" />,
                        // caption: <FormattedMessage id="menuitems-admin-tplmgmt-followup-caption" />,
                        type: 'item',
                        url: '/admin/tplmgmt/followup/list',
                        icon: <ViewQuiltTwoToneIcon fontSize="small" />
                    }
                ]
            }
        ]
    },
    {
        id: 'system',
        title: <FormattedMessage id="menuitems-system-title" />,
        // caption: <FormattedMessage id="menuitems-system-caption" />,
        type: 'group',
        children: [
            {
                id: 'system-nomcltr',
                title: <FormattedMessage id="menuitems-system-nomcltr-title" />,
                // caption: <FormattedMessage id="menuitems-system-nomcltr-caption" />,
                type: 'collapse',
                icon: <WidgetsTwoToneIcon fontSize="small" />,
                children: [
                    {
                        id: 'system-nomcltr-busopptype',
                        title: <FormattedMessage id="menuitems-system-nomcltr-busopptype-title" />,
                        // caption: <FormattedMessage id="menuitems-system-nomcltr-busopptype-caption" />,
                        type: 'item',
                        url: '/system/nomcltr/busopp-type/list',
                        icon: <AccountTreeTwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'system-nomcltr-workordertype',
                        title: <FormattedMessage id="menuitems-system-nomcltr-workordertype-title" />,
                        // caption: <FormattedMessage id="menuitems-system-nomcltr-workordertype-caption" />,
                        type: 'item',
                        url: '/system/nomcltr/workorder-type/list',
                        icon: <AccountTreeTwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'system-nomcltr-contracttype',
                        title: <FormattedMessage id="menuitems-system-nomcltr-contracttype-title" />,
                        // caption: <FormattedMessage id="menuitems-system-nomcltr-contracttype-caption" />,
                        type: 'item',
                        url: '/system/nomcltr/contract-type/list',
                        icon: <DescriptionTwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'system-nomcltr-tickettype',
                        title: <FormattedMessage id="menuitems-system-nomcltr-tickettype-title" />,
                        // caption: <FormattedMessage id="menuitems-system-nomcltr-tickettype-caption" />,
                        type: 'item',
                        url: '/system/nomcltr/ticket-type/list',
                        icon: <ConfirmationNumberTwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'system-nomcltr-partnershiptype',
                        title: <FormattedMessage id="menuitems-system-nomcltr-partnershiptype-title" />,
                        // caption: <FormattedMessage id="menuitems-system-nomcltr-contracttype-caption" />,
                        type: 'item',
                        url: '/system/nomcltr/partnership-type/list',
                        icon: <HandshakeTwoToneIcon fontSize="small" />
                    }
                ]
            },
            {
                id: 'system-security',
                title: <FormattedMessage id="menuitems-system-security-title" />,
                // caption: <FormattedMessage id="menuitems-system-security-caption" />,
                type: 'collapse',
                icon: <SecurityTwoToneIcon fontSize="small" />,
                children: [
                    {
                        id: 'system-security-user',
                        title: <FormattedMessage id="menuitems-system-security-user-title" />,
                        // caption: <FormattedMessage id="menuitems-system-security-user-caption" />,
                        type: 'item',
                        url: '/system/security/user/list',
                        icon: <PeopleAltTwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'system-security-group',
                        title: <FormattedMessage id="menuitems-system-security-group-title" />,
                        // caption: <FormattedMessage id="menuitems-system-security-group-caption" />,
                        type: 'item',
                        url: '/system/security/group/list',
                        icon: <GroupsTwoToneIcon fontSize="small" />
                    }
                ]
            },
            {
                id: 'system-log',
                title: <FormattedMessage id="menuitems-system-log-title" />,
                // caption: <FormattedMessage id="menuitems-system-log-caption" />,
                type: 'collapse',
                icon: <Inventory2TwoToneIcon fontSize="small" />,
                children: [
                    {
                        id: 'system-log-busopparchive',
                        title: <FormattedMessage id="menuitems-system-log-busopparchive-title" />,
                        // caption: <FormattedMessage id="menuitems-system-log-busopparchive-caption" />,
                        type: 'item',
                        url: '/system/log/busopp-archive/list',
                        icon: <Inventory2TwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'system-log-workorderarchive',
                        title: <FormattedMessage id="menuitems-system-log-workorderarchive-title" />,
                        // caption: <FormattedMessage id="menuitems-system-log-workorderarchive-caption" />,
                        type: 'item',
                        url: '/system/log/workorder-archive/list',
                        icon: <Inventory2TwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'system-log-operation',
                        title: <FormattedMessage id="menuitems-system-log-operation-title" />,
                        // caption: <FormattedMessage id="menuitems-system-log-operation-caption" />,
                        type: 'item',
                        url: '/system/log/operation/list',
                        icon: <Inventory2TwoToneIcon fontSize="small" />
                    },
                    {
                        id: 'system-log-commandexecution',
                        title: <FormattedMessage id="menuitems-system-log-commandexecution-title" />,
                        // caption: <FormattedMessage id="menuitems-system-log-commandexecution-caption" />,
                        type: 'item',
                        url: '/system/log/command-execution/list',
                        icon: <EventRepeatTwoToneIcon fontSize="small" />
                    }
                ]
            },
            {
                id: 'system-appsettings',
                title: <FormattedMessage id="menuitems-system-appsettings-title" />,
                // caption: <FormattedMessage id="menuitems-system-appsettings-caption" />,
                type: 'item',
                url: '/admin/appsettings/',
                icon: <SettingsTwoToneIcon fontSize="small" />
            }
        ]
    }
];

export default baseSideMenu;
